import { PersonMapping } from '@bp/shared-planung-utils';
import { ArrowHeadRightIcon, Select, SelectOptionType } from '@bp/ui-components';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { lowercaseFirstLetter, naturalStringSort } from '../../../utils/stringHelper';
import { XlsxImportEntry } from '../types/XlsxImportTypes';
import styles from './_XlsxImportForms.module.scss';

type XlsxTeacherMappingFormRowProps = {
  id: number;
  entry: XlsxImportEntry<PersonMapping>;
  profiles: { uuid: string; name: string }[];
  selectedProfile: { uuid: string; name: string } | null;
  onProfileSelect: (id: number, uuid: string | null) => void;
};

export const XlsxTeacherMappingFormRow = ({
  id,
  entry,
  profiles,
  selectedProfile,
  onProfileSelect,
}: XlsxTeacherMappingFormRowProps) => {
  const { t } = useTranslation();

  const { firstName, lastName, rowIndex } = entry;

  const profileOptions: SelectOptionType[] = profiles
    .map((p) => ({ value: p.uuid, label: p.name }))
    .sort((a, b) => naturalStringSort(a.label, b.label));

  return (
    <div className={classNames(styles['xlsx-mapping-form-row'], styles.teachers)}>
      <div className={styles.name}>
        {firstName} {lastName}
      </div>
      <div className={styles.icon}>
        <ArrowHeadRightIcon />
      </div>
      <div className={styles.select}>
        <Select
          dense
          options={profileOptions}
          name={`select-profile-${id}`}
          placeholder={lowercaseFirstLetter(t('import.willBeCreated'))}
          onChange={(event) => {
            const selectOption = event as SelectOptionType;
            const uuid = selectOption ? (selectOption.value as string) : null;
            onProfileSelect(rowIndex, uuid);
          }}
          value={selectedProfile ? { value: selectedProfile.uuid, label: selectedProfile.name } : undefined}
          isClearable
          isSearchable
          menuPosition='fixed'
        />
      </div>
    </div>
  );
};
